import TableContainer from '@mui/material/TableContainer'
import DialogTitle from '@mui/material/DialogTitle'
import {styled} from '@mui/material/styles'
import {TableCell, Typography} from '@mui/material'
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.titleMedium.fontSize
}))

export const StyledTableContainer = styled(TableContainer)(({theme}) => ({
  border: `1px solid ${theme.palette.hpBaseLight}`,
  borderCollapse: 'collapse'
}))

export const ErrorBox = styled(Typography)(({theme}) => ({
  color: theme.palette.error.main,
  padding: '0.5rem',
  fontStyle: 'italic'
}))

export const StyledTableCell = styled(TableCell, {shouldForwardProp: (prop) => prop !== 'isAction'})(({isAction}) => ({
  minWidth: isAction ? '100px' : '300px'
}))

export const StyledInputBase = styled(InputBase, {shouldForwardProp: (prop) => prop !== 'isError'})(
  ({theme, isError}) => ({
    color: isError ? theme.palette.error.main : theme.palette.hpAccentBlack,
    padding: '8px 16px',
    '&.Mui-disabled': {
      color: isError ? theme.palette.error.main : theme.palette.hpAccentBlack
    },
    '& input:disabled': {
      color: isError ? theme.palette.error.main : theme.palette.hpAccentBlack,
      WebkitTextFillColor: isError ? theme.palette.error.main : theme.palette.hpAccentBlack
    }
  })
)

export const StyledButton = styled(IconButton)(({theme}) => ({
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryLightest
  },
  '&:disabled': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.hpBaseLight
    }
  }
}))

export const StyledTableContentCell = styled(TableCell, {shouldForwardProp: (prop) => prop !== 'isError'})(
  ({theme, isError}) => ({
    border: `${isError ? '2px' : '1px'} solid ${isError ? theme.palette.error.main : theme.palette.hpBaseLight}`,
    color: isError ? theme.palette.error.main : theme.palette.hpBlack
  })
)
